class MassagerReviews {
  constructor(section) {
    this.section = section;
    this.button = section.querySelector('.massager-show-more');
    this.cards = section.querySelectorAll('.massager-review-card');
    this.visible = 10;

    if (!this.button || !this.cards.length) return;

    this.button.addEventListener('click', () => this.showMore());
  }

  showMore() {
    for (let i = this.visible; i < this.visible + 10 && i < this.cards.length; i++) {
      this.cards[i].classList.add('is-visible');
    }

    this.visible += 10;

    if (this.visible >= this.cards.length) {
      this.button.style.display = 'none';
    }
  }
}

/* Shopify section lifecycle */
document.addEventListener('shopify:section:load', (e) => {
  const section = e.target.querySelector('[data-massager-reviews]');
  if (section) new MassagerReviews(section);
});

/* Initial load */
document.querySelectorAll('[data-massager-reviews]').forEach(section => {
  new MassagerReviews(section);
});
